export default __webpack_public_path__ + "static/media/Icon_mic.138633c7.svg";